import { helpers } from "@vuelidate/validators";

const regexps = {
    phone_exp: new RegExp(/^(\+98|0098|98|0)?9\d{9}$/g),
    email_exp: new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
    digit_exp: new RegExp(/[0-9]/),
    float_exp: new RegExp(/^[+-]?\d+(\.\d+)?$/),
    persian_digit_exp: new RegExp(/[۰-۹]/),
    uppercase_exp: new RegExp(/[A-Z]/),
    char_exp: new RegExp(/\W|_/g),
    persianName_exp: new RegExp(/^[ آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئ\s]+$/),
    englishName_exp: new RegExp(/^[ a-zA-Z]+$/),
    alias_exp: new RegExp(/[a-zA-Z0-9آ-ی]/),
    number_exp: new RegExp(/^\d+$/),
    id_exp: new RegExp(/^[a-zA-Z]{3}[0-9]{6}$/),
    username_exp: new RegExp(/^([a-zA-Z0-9]|[-._](?![-._])){4,20}$/),
    campaginName_exp: new RegExp(/^([a-zA-Z0-9آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئ]|[-._](?![-._])){4,20}$/),
    links_exp: new RegExp(/(https?:\/\/[^ ]*)/),
    shaba_exp: new RegExp(/^(?=.{24}$)[0-9]*$/),
    userName_exp: new RegExp(/^[a-zA-z]{2,}\d*$/),
    national_exp: new RegExp(/0\d{9}$/g),
}


//***** 
//*** params (param) 
//***** 
export function mobileChecker(param) {
    if (!param.match(regexps.phone_exp)) {
        return {
            $valid: false,
            $message: `شماره همراه نا معتبر`,
            $params: param
        }
    } else {
        return {
            $valid: true,
            $message: '',
            $params: { param }
        };
    }
}
export function nationalChecker(param) {
    if (!param.match(regexps.national_exp)) {
        return {
            $valid: false,
            $message: `کد ملی نامعتبر است`,
            $params: param
        }
    } else {
        return {
            $valid: true,
            $message: '',
            $params: { param }
        };
    }
}
export function usernameChecker(param) {
    if (!param.match(regexps.userName_exp)) {
        return {
            $valid: false,
            $message: `لطفا فقط از اعداد و حروف استفاده کنید`,
            $params: param
        }
    } else {
        return {
            $valid: true,
            $message: '',
            $params: { param }
        };
    }
}